import { useMemo } from "react"
import { routerConfig } from "./router-config.tsx"
import useDeviceBreakpoint from "@/hooks/use-device-breakpoint.ts"

export const useRouter = () => {
  const { isDesktop, isTablet } = useDeviceBreakpoint()

  console.log("Router isDesktop", isDesktop)
  console.log("Router isTablet", isTablet)

  return useMemo(() => {
    return routerConfig(isDesktop || isTablet)
  }, [isDesktop])
}
